package com.anjuros.website.redesign.sections.pricing

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdBreadcrumb
import com.anjuros.website.redesign.components.RdLede
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.styles.PricingFactLabelStyle
import com.anjuros.website.redesign.styles.PricingHeroStyle
import com.anjuros.website.redesign.styles.PricingSplitFactsStyle
import com.anjuros.website.redesign.styles.RdHeroCopyStyle
import com.anjuros.website.redesign.styles.RdMarkStyle
import com.anjuros.website.redesign.styles.RdSubpageTitleStyle
import com.anjuros.website.redesign.util.RdText
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun PricingHeroSection() {
    RdSection(labelledBy = "h1", modifier = PricingHeroStyle.toModifier(), wrapModifier = RdHeroCopyStyle.toModifier()) {
        RdBreadcrumb(RdText.PRICING_CRUMB)
        H1(RdSubpageTitleStyle.toModifier().id("h1").toAttrs()) {
            Text(LocalText(RdText.PRICING_HERO_TITLE_START))
            Span(RdMarkStyle.toModifier().toAttrs()) { Text(LocalText(RdText.PRICING_HERO_TITLE_MARK)) }
        }
        RdLede(RdText.PRICING_HERO_LEDE)
        // Kept as two separate boxes so the one-off fee and the monthly plan never read as one offer.
        Div(PricingSplitFactsStyle.toModifier().toAttrs()) {
            Fact(RdText.PRICING_FACT_WEBSITE_LABEL, RdText.PRICING_FACT_WEBSITE_BOLD, RdText.PRICING_FACT_WEBSITE_TEXT)
            Fact(RdText.PRICING_FACT_PLAN_LABEL, RdText.PRICING_FACT_PLAN_BOLD, RdText.PRICING_FACT_PLAN_TEXT)
        }
    }
}

@Composable
private fun Fact(label: RdText, bold: RdText, text: RdText) {
    Div {
        P(PricingFactLabelStyle.toModifier().toAttrs()) { Text(LocalText(label)) }
        P {
            B { Text(LocalText(bold)) }
            Text(LocalText(text))
        }
    }
}
